import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { DeviceProviderCreateRequest, DeviceProviderResponse, DeviceProviderUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { DeviceProviderDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { DeviceProviderParametersSectionHandler } from './parameters.section';
import { HealthIssueService } from '../healthissues/healthissue.service';
import { DomSanitizer } from '@angular/platform-browser';

@RegisterEntityHandler('deviceprovider')
@Injectable()
export class DeviceProviderHandler extends EntityHandler<DeviceProviderResponse> {

    constructor(
        admin: AdminEditorService,
        private issues: HealthIssueService,
        private sanitizer: DomSanitizer
    ) {
        super(admin);
    }

    states = ['active', 'suspended', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listDeviceProviders/${ownerId}/false/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listDeviceProviders(ownerId, false, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'deviceprovider',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.DEVICEPROVIDERS'),
        }));
    }

    getEntity(id: string): Promise<DeviceProviderResponse> {
        return this.admin.getCached(`getDeviceProvider/${id}`, api => api.entities.getDeviceProvider(id), 10);
    }

    createEntity(ownerId: string, entity: DeviceProviderCreateRequest): Promise<DeviceProviderResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createDeviceProvider(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateDeviceProvider(entity.id, { state: state as any }));
    }   

    async getGridColumns(ownerId: string): Promise<IKuiTableCol[]> {
        const types = await this.admin.getCached(`listDeviceProviderTypes/${ownerId}/0/100/name/null`, api => api.entities.listDeviceProviderTypes(ownerId, 0, 100, 'name', null));
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.DEVICEPROVIDER.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', ICONS.deviceprovider),
            grid.IdNameComboColumn('deviceProviderType', 'TYPE', types.items.map(x => ({ id: x.id, value: x.name })), 100),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    async getEditorSections(ownerId: string, entity: any): Promise<SectionHandlerGroup<DeviceProviderResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new DeviceProviderDetailsSectionHandler(this.admin, ownerId, false),
                new DeviceProviderParametersSectionHandler(this.admin, ownerId, false),
            ],
            warnings: entity ? (await this.issues.getIssuesForEntity(ownerId, entity.id, 1)).map(issue => {
                return this.sanitizer.bypassSecurityTrustHtml(`${issue.description}<br><a href="/#/admin/client/${entity.owner.id}/healthissues/grid/healthissue/${issue.id}">More</a>`);
            }) : [],            
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: DeviceProviderUpdateRequest, sections: FormSectionHandler<DeviceProviderResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'deviceprovider',
            entity: {}, // set up some defaults if you want
            sections: [
                new DeviceProviderDetailsSectionHandler(this.admin, ownerId, true),
                new DeviceProviderParametersSectionHandler(this.admin, ownerId, true),
            ],
        });
    }

}












